import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

const englishL18n = {
  firstName: "First name",
  lastName: "Last name",
  title: "Title",
  title_01: "Mr.",
  title_02: "Mrs.",
  title_03: "Ms.",
  title_04: "Mx.",
  perfumeName: "Perfum's name",
  noteDeTete: "Head note",
  notesDeTete: "Head notes",
  noteDeCoeur: "Heart note",
  notesDeCoeur: "Heart notes",
  noteDeFond: "Base note",
  notesDeFond: "Base notes",
  atelierDeCreation: "Galimard perfume creation workshop",
  atelierDeCreationParis: "Galimard perfume creation workshop in Paris",
  atelierDeCreationPromo:
    "Create your own unique fragrance and take home your personalized 100ml Eau de Parfum",
  bookButtonTitle: "Booking on galimard.com",
  creerUnNouveauParfum: "Create a new perfume",
  confirmNewPerfume:
    "The current formula will be finalized and can no longer be modified. Create a new perfume?",
  identificationStep: "Identification",
  perfumeStep: "Perfume",
  diplomaStep: "Diploma",
  chooseAnIngredient: "Choose an ingredient",
  ajouterUneNote: "Add a",
  suggestIngredients: "Suggest ingredients",
  suggestionTitle: "Our suggestions",
  suggestionPairedWith: "Goes well with {{ingredients}}",
  suggestionPopular: "Found in {{percent}}% of our perfumes",
  suggestionVolume: "Suggested volume: {{volume}} ml",
  suggestionAdd: "Add",
  suggestionAdded: "Added",
  suggestionClose: "Close",
  suggestionForYou: "For you",
  suggestionStyles: "Styles",
  suggestionStyleReason: "In {{percent}}% of the perfumes of this style",
  suggestionBudget: "{{used}} ml of about {{usual}} ml",
  suggestionBudgetFull: "complete (about {{usual}} ml)",
  suggestionBottleLeft: "{{volume}} ml left in the {{bottle}} ml bottle",
  suggestionBottleFull: "The {{bottle}} ml bottle is full",
  totalVolumeOverBottle: "more than the {{bottle}} ml bottle",
  totalVolume: "Total volume",
  navNext: "Next",
  navBack: "Back",
  navLastStep: "See my diploma",
  perfumeLocked: "This formula is finalized and can no longer be modified.",
  perfumeStaffOnly: "This formula can only be modified on the workshop tablets.",
  lockPerfume: "Lock the formula",
  lockPerfumeConfirmation:
    "Staff only. Once locked, the formula can no longer be modified (only an administrator can unlock it).",
  lockPerfumeCode: "Staff code",
  lockPerfumeWrongCode: "Wrong code",
  lockPerfumeError: "The formula could not be locked.",
  sendByEmail: "Send by email",
  sendByEmailTitle: "Send my formula by email",
  sendByEmailText: "You will receive the composition of your formula and the link to your diploma.",
  sendByEmailSend: "Send",
  sendByEmailInvalid: "Invalid email address",
  sendByEmailSent: "Email sent to {{email}}",
  sendByEmailTooMany: "This formula has already been sent too many times.",
  sendByEmailError: "The email could not be sent. Please ask the staff.",
  perfumeStaleEmpty:
    "This formula was prepared more than 6 hours ago. Create a new formula to start.",
  saveError: "Your last changes could not be saved. This formula can no longer be modified.",
  summaryCreated: "Creation in workshop on {{date}}",
  summaryLocation: "at {{location}}",
  summaryFormulaNumber: "Formula number :",
  summaryComponentsVolume: "This perfume has {{numberOfComponents}} components for {{volume}} ml",
  showDiploma: "Show diploma",
  deleteComponentConfirmation: "Are you sure you want to delete this note?",
  cancel: "Cancel",
  confirm: "Confirm",
  addVolume: "Add volume",
  delete: "Delete",
  tipMessage:
    "Tipping is like a perfume, not required, but if our perfumer has managed to enchant you, it will surely be appreciated.",
  tabletMessage: "Please refrain from spraying perfume on the iPad; it prefers to remain neutral.",
  comment: "Comment",
  detailsPerfume: "Perfume",
  detailsCreatedBy: "created by {{author}}",
  detailsCreatedOn: "Created on {{date}}",
  detailsCreatedOnAt: "Created on {{date}} at {{location}}",
  detailsLockedOn: "Locked on {{date}}",
  detailsIngredientName: "Name",
  detailsGalimardReference: "Galimard reference",
  detailsLotNumber: "Lot number",
  detailsVolume: "Volume",
  detailsTotal: "Total:",
  detailsEdit: "Edit perfume",
  detailsUnlock: "Unlock",
  detailsDeleteConfirmation: "Are you sure you want to delete the perfume? {{perfume}}",
  detailsDeleteConfirmationAuthor: "made by {{author}}",
};

const frenchL18N: typeof englishL18n = {
  firstName: "Prénom",
  lastName: "Nom",
  title: "Titre",
  title_01: "Monsieur",
  title_02: "Madame",
  title_03: "",
  title_04: "",
  perfumeName: "Nom du parfum",
  noteDeTete: "Note de tête",
  notesDeTete: "Notes de tête",
  noteDeCoeur: "Note de cœur",
  notesDeCoeur: "Notes de cœur",
  noteDeFond: "Note de fond",
  notesDeFond: "Notes de fond",
  atelierDeCreation: "Atelier de création de parfum Galimard",
  atelierDeCreationParis: "Atelier de création de Parfum Galimard à Paris",
  atelierDeCreationPromo:
    "Créez votre fragrance unique et repartez avec votre Eau de Parfum 100ml personnalisée",
  bookButtonTitle: "Réservation sur galimard.com",
  creerUnNouveauParfum: "Créer un nouveau parfum",
  confirmNewPerfume:
    "La formule en cours sera finalisée et ne pourra plus être modifiée. Créer un nouveau parfum ?",
  identificationStep: "Identification",
  perfumeStep: "Parfum",
  diplomaStep: "Diplôme",
  chooseAnIngredient: "Choisissez un ingredient",
  ajouterUneNote: "Ajouter une",
  suggestIngredients: "Proposez-moi des ingrédients",
  suggestionTitle: "Nos suggestions",
  suggestionPairedWith: "Se marie souvent avec {{ingredients}}",
  suggestionPopular: "Présent dans {{percent}} % de nos parfums",
  suggestionVolume: "Volume conseillé : {{volume}} ml",
  suggestionAdd: "Ajouter",
  suggestionAdded: "Ajouté",
  suggestionClose: "Fermer",
  suggestionForYou: "Pour vous",
  suggestionStyles: "Styles",
  suggestionStyleReason: "Dans {{percent}} % des parfums de ce style",
  suggestionBudget: "{{used}} ml sur environ {{usual}} ml",
  suggestionBudgetFull: "complètes (environ {{usual}} ml)",
  suggestionBottleLeft: "Il reste {{volume}} ml dans le flacon de {{bottle}} ml",
  suggestionBottleFull: "Le flacon de {{bottle}} ml est plein",
  totalVolumeOverBottle: "dépasse le flacon de {{bottle}} ml",
  totalVolume: "Volume total",
  navNext: "Suivant",
  navBack: "Retour",
  navLastStep: "Voir mon diplôme",
  perfumeLocked: "Cette formule est finalisée et ne peut plus être modifiée.",
  perfumeStaffOnly: "Cette formule ne peut être modifiée que sur les tablettes de l'atelier.",
  lockPerfume: "Verrouiller la formule",
  lockPerfumeConfirmation:
    "Réservé au personnel. Une fois verrouillée, la formule ne peut plus être modifiée (seul un administrateur peut la déverrouiller).",
  lockPerfumeCode: "Code du personnel",
  lockPerfumeWrongCode: "Code incorrect",
  lockPerfumeError: "La formule n'a pas pu être verrouillée.",
  sendByEmail: "Envoyer par email",
  sendByEmailTitle: "Recevoir ma formule par email",
  sendByEmailText: "Vous recevrez la composition de votre formule et le lien vers votre diplôme.",
  sendByEmailSend: "Envoyer",
  sendByEmailInvalid: "Adresse email invalide",
  sendByEmailSent: "Email envoyé à {{email}}",
  sendByEmailTooMany: "Cette formule a déjà été envoyée trop de fois.",
  sendByEmailError: "L'email n'a pas pu être envoyé. Merci de vous adresser au personnel.",
  perfumeStaleEmpty:
    "Cette formule a été préparée il y a plus de 6 heures. Créez une nouvelle formule pour commencer.",
  saveError:
    "Vos dernières modifications n'ont pas pu être enregistrées. Cette formule ne peut plus être modifiée.",
  summaryCreated: "Création en atelier le {{date}}",
  summaryLocation: "au {{location}}",
  summaryFormulaNumber: "Numéro de formule :",
  summaryComponentsVolume:
    "Ce parfum comporte {{numberOfComponents}} composants pour {{volume}} ml",
  showDiploma: "Voir le diplôme",
  deleteComponentConfirmation: "Voulez-vous enlever cette note ?",
  cancel: "Annuler",
  confirm: "Confirmer",
  addVolume: "Ajouter un volume",
  delete: "Supprimer",
  tipMessage:
    "Le pourboire est comme un parfum, nullement obligatoire; Cependant, si notre parfumeur a su vous enchanter, celui-ci sera accueilli avec gratitude.",
  tabletMessage: "Merci de ne pas parfumer l'iPad, il préfère rester neutre !",
  comment: "Commentaire",
  detailsPerfume: "Parfum",
  detailsCreatedBy: "créé par {{author}}",
  detailsCreatedOn: "Créé le {{date}}",
  detailsCreatedOnAt: "Créé le {{date}} au {{location}}",
  detailsLockedOn: "Verrouillé le {{date}}",
  detailsIngredientName: "Nom",
  detailsGalimardReference: "Référence Galimard",
  detailsLotNumber: "Numéro de lot",
  detailsVolume: "Volume",
  detailsTotal: "Total :",
  detailsEdit: "Modifier le parfum",
  detailsUnlock: "Déverrouiller",
  detailsDeleteConfirmation: "Voulez-vous vraiment supprimer le parfum ? {{perfume}}",
  detailsDeleteConfirmationAuthor: "créé par {{author}}",
};

declare module "i18next" {
  // Extend CustomTypeOptions
  interface CustomTypeOptions {
    // custom namespace type, if you changed it
    defaultNS: "translation";
    // custom resources type
    resources: {
      translation: typeof englishL18n;
    };
  }
}

export function initializeI18n() {
  i18next
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      fallbackLng: "fr",
      debug: false,
      interpolation: {
        escapeValue: false,
      },
      resources: {
        en: {
          translation: englishL18n,
        },
        fr: {
          translation: frenchL18N,
        },
      },
    });
}
